module.exports = __webpack_public_path__ + "static/media/Drone.fdcf3f57.svg";